import { copy } from '../helpers/ObjectHelper';

export function categorizePublications(publications) {
  const emptyYearTemplate = {
    1: [],
    2: [],
    3: [],
    4: [],
  };

  const categorizedPublications = {};

  const uniqueYears = new Set(publications.map(publication => publication.year));
  [...uniqueYears].forEach((year) => { categorizedPublications[year] = copy(emptyYearTemplate); });

  publications.forEach((publication) => {
    categorizedPublications[publication.year][publication.type].push(publication);
  });

  return categorizedPublications;
}

export function flattenCategorizedPublications(categorizedPublications) {
  const years = Object.keys(categorizedPublications).sort((a, b) => b - a);
  const categories = Object.keys(categorizedPublications[years[0]]);

  const orderedPublicationsList = [];
  years.forEach((year) => {
    categories.forEach((category) => {
      orderedPublicationsList.push(...categorizedPublications[year][category]);
    });
  });

  return orderedPublicationsList;
}

export const publicationTypes = {
  1: 'JOURNAL',
  2: 'CONFERENCE',
  3: 'BOOKS AND CHAPTERS',
  4: 'INTELECTUAL PROPERTY',
};
